module.exports = __webpack_public_path__ + "static/media/goalcard_gift.e9932fe6.svg";